<script setup lang="ts">
import LeIconButton from "@dsk/components/IconButton/LeIconButton.vue";
import LeTooltip from "@dsk/components/LeTooltip.vue";
import LeFeedback from "@dsk/icons/LeFeedback.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";

import LeFeedbackModal from "@/components/feedback-modal/LeFeedbackModal.vue";

const { t } = useI18n();

const isModalOpen = ref<boolean>(false);

const onModalClose = (didSubmit: boolean) => {
  isModalOpen.value = false;

  if (didSubmit) {
    const toast = useToast();
    toast.clear();
    toast(t("le-feedback-button.toast"));
  }
};
</script>

<template>
  <LeTooltip :text="t('le-feedback-button.text')" :margin-bottom="10">
    <LeIconButton @click="isModalOpen = true">
      <LeFeedback />

      <LeFeedbackModal :is-open="isModalOpen" @close="onModalClose($event)" />
    </LeIconButton>
  </LeTooltip>
</template>
